var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "34px",
    viewBox: "0 0 46 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9EF75F1E-FB03-42BA-B9AF-8E34A48EF6AE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eazle---New-menu-and-order-pages-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Update-stock-count",
    transform: "translate(-130, -216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filter-button",
    transform: "translate(130, 216)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CEFAB7",
    x: 0,
    y: 0,
    width: 46,
    height: 34,
    rx: 17
  }), /*#__PURE__*/React.createElement("g", {
    id: "filter-icon",
    transform: "translate(11, 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2222222,18 C10.15926,18 10.1064822,17.9042 10.0638889,17.7125 C10.0212956,17.5208 10,17.2833 10,17 C10,16.7167 10.0212956,16.4792 10.0638889,16.2875 C10.1064822,16.0958 10.15926,16 10.2222222,16 L13.7777778,16 C13.8407333,16 13.8935111,16.0958 13.9361111,16.2875 C13.9787111,16.4792 14,16.7167 14,17 C14,17.2833 13.9787111,17.5208 13.9361111,17.7125 C13.8935111,17.9042 13.8407333,18 13.7777778,18 L10.2222222,18 Z M6.66666667,13 C6.47778,13 6.31944667,12.9042 6.19166667,12.7125 C6.06388667,12.5208 6,12.2833 6,12 C6,11.7167 6.06388667,11.4792 6.19166667,11.2875 C6.31944667,11.0958 6.47778,11 6.66666667,11 L17.3333333,11 C17.5222,11 17.6805333,11.0958 17.8083333,11.2875 C17.9361333,11.4792 18,11.7167 18,12 C18,12.2833 17.9361333,12.5208 17.8083333,12.7125 C17.6805333,12.9042 17.5222,13 17.3333333,13 L6.66666667,13 Z M4,8 C3.71667,8 3.47917,7.90417 3.2875,7.7125 C3.09583,7.52083 3,7.28333 3,7 C3,6.71667 3.09583,6.47917 3.2875,6.2875 C3.47917,6.09583 3.71667,6 4,6 L20,6 C20.2833,6 20.5208,6.09583 20.7125,6.2875 C20.9042,6.47917 21,6.71667 21,7 C21,7.28333 20.9042,7.52083 20.7125,7.7125 C20.5208,7.90417 20.2833,8 20,8 L4,8 Z",
    id: "Shape",
    fill: "#00414B",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterButton);
export default __webpack_public_path__ + "static/media/filter-button.841b9a797043038407b0b5bcf776a80b.svg";
export { ForwardRef as ReactComponent };